import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  returnLabelWarning: {
    description: 'otherShippingOptions.returnLabelWarning',
    defaultMessage:
      'Please note: some carriers charge fees for return labels whether or not they are used. These charges will not be reflected in the rate quoted for the outgoing shipping label. Please contact your carrier account manager for more details. Return labels are not supported for international shipments.',
    id: '+gJybp',
  },
  packageDefaultText: {
    description: 'otherShippingOptions.packageDefaultText',
    defaultMessage: 'Select a Package',
    id: 'jfmN6+',
  },
  packageLabel: {
    description: 'otherOptions.packageLabel',
    defaultMessage: 'Package',
    id: 'SjR4rd',
  },
  serviceLabel: {
    description: 'otherOptions.serviceLabel',
    defaultMessage: 'Service',
    id: 'kW59Cw',
  },
});
